import type { FC } from 'react';

import Avatar from 'components/Avatar/Avatar';
import Typography from 'components/Typography/Typography';
import { useUserProfile } from 'contexts/UserProfileContext';
import { getUserPlaceholderName } from 'helpers/user';

import { DataWrapStyled } from './UserProfile.styled';
import UserProfileLoader from './UserProfileLoader';

const UserProfile: FC = () => {
  const { userProfile, isLoadingUserProfile } = useUserProfile();

  return (
    <div>
      {isLoadingUserProfile ? (
        <UserProfileLoader />
      ) : (
        <>
          <Avatar
            size="lg"
            placeholder={getUserPlaceholderName(
              userProfile?.displayName?.split(' ')[0],
              userProfile?.displayName?.split(' ')[1]
            )}
            imageUrl={userProfile?.photoUrl}
          />
          <DataWrapStyled justify="start">
            <img src="/images/user-icon.png" alt="user" />
            <Typography variant="h5" color="darkBlue">
              {userProfile?.displayName}
            </Typography>
          </DataWrapStyled>
          <DataWrapStyled justify="start">
            <img src="/images/email-icon.png" alt="user" />
            <Typography variant="h5" color="darkBlue">
              {userProfile?.emailAddress}
            </Typography>
          </DataWrapStyled>
          {userProfile?.phoneNumber && (
            <DataWrapStyled justify="start">
              <img src="/images/phone-icon.png" alt="user" />
              <Typography variant="h5" color="darkBlue">
                `+${userProfile.phoneNumber}`
              </Typography>
            </DataWrapStyled>
          )}
        </>
      )}
    </div>
  );
};

export default UserProfile;
